import { useParams } from 'react-router-dom';

import StudentImportCompare from './StudentImportCompare';
import StudentImportList from './StudentImportList';

// The import_students Screen: the list of imports, or one import's
// comparison at /apps/<app>/import_students/compare/<id>.
const StudentImport = () => {
  const { operation, id } = useParams<{ operation?: string; id?: string }>();
  return operation === 'compare' && id ? <StudentImportCompare /> : <StudentImportList />;
};

export default StudentImport;
